import React, { useEffect } from "react";
import { AUDITS } from "../../core/theme/auditsTheme";
import { useAccount } from "../../core/hooks/useAccount";
import { canUseIndustryAudits } from "../../core/data/account";
import AuditsSidePanel from "./components/AuditsSidePanel";
import SnapshotsList from "./components/SnapshotsList";
import IndustryAuditsPage from "./IndustryAuditsPage";
import useWebsiteSearch from "./useWebsiteSearch";

// The Audits page. Accounts with Industry Audits get the industry layout
// (IndustryAuditsPage); everyone else keeps the stage 1 page: two columns,
// placeholders on the left, every snapshot grouped by niche on the right,
// searchable by name, tag or advertiser website.
export default function JobsScreen(props) {
  const account = useAccount();
  return canUseIndustryAudits(account) ? <IndustryAuditsPage {...props} /> : <StageOnePage {...props} />;
}

function StageOnePage({ agencyId, jobs, jobsLoading, jobSearch, setJobSearch, onOpenJob, onOpenPinned, onStopJob, onNewScan }) {
  const website = useWebsiteSearch(agencyId, jobSearch);

  // This page keeps nothing in the address.
  useEffect(() => {
    if (window.location.search) window.history.replaceState(null, "", window.location.pathname);
  }, []);

  return (
    <div className={AUDITS.page}>
      <AuditsSidePanel />
      <SnapshotsList
        jobs={jobs} jobsLoading={jobsLoading} jobSearch={jobSearch} setJobSearch={setJobSearch} website={website}
        onOpenJob={onOpenJob} onOpenPinned={onOpenPinned} onStopJob={onStopJob} onNewScan={onNewScan}
      />
    </div>
  );
}
